import { Feather } from "@expo/vector-icons";
import { Text, TouchableOpacity, View } from "react-native";

const MenuOption = ({ title, onPress, lastElement }: { title: string; onPress(): void; lastElement?: boolean }) => {
  return (
    <TouchableOpacity onPress={onPress}>
      <View className={`p-4 border-b border-sky-light ${lastElement ? "border-b-0" : ""}`}>
        <View className="flex flex-row items-center">
          <Text className="text-regular-normal text-ink-darker flex-[0.7]">{title}</Text>
          <View className="flex-[0.3] items-end">
            <Feather name="chevron-right" size={24} />
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default MenuOption;
